'use strict';

export default class OPLReadingLists {

    constructor() {
        this.readingLists = document.querySelectorAll('.opl-widget-reading-lists');
    }

    init() {
        if (this.readingLists.length) {
            this.readingLists.forEach(list => {
                this.handleTabs(list);
                this.handleDropdownTabs(list);
                this.initCarousels(list);
            });
        }
    }

    initCarousels(list) {
        const carousels = list.querySelectorAll('[data-carousel="loop"]');

        carousels.forEach(carouselEl => {
            const config = {
                loop: true,
                centeredSlides: false,
                slidesPerView: 'auto',
                clickable: false,
                a11y: true,
                grabCursor: true,
                keyboard: { enabled: true },
                breakpoints: {
                    320: { slidesPerView: 1 },
                    640: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                    1280: { slidesPerView: 5 }
                },
                navigation: {
                    nextEl: carouselEl.parentElement.querySelector('.swiper-button-next'),
                    prevEl: carouselEl.parentElement.querySelector('.swiper-button-prev')
                },
                on: {
                    init: (swiper) => {
                        swiper.slides.forEach(slide => {
                            slide.querySelectorAll('img').forEach(img => {
                                if (img.complete) {
                                    this.changeImgSrcToDefault(img);
                                } else {
                                    img.onload = () => this.changeImgSrcToDefault(img);
                                    img.onerror = () => this.changeImgSrcToDefault(img);
                                }
                            });
                        });
                    }
                }
            };

            // we are importing the swiper library
            // within the OPLSwiper class (OPL.Swiper.js)
            window.OPL.Swiper.initSwiper(carouselEl, config);
        });
    }

    changeImgSrcToDefault(imgElement) {
        if (!imgElement || imgElement.naturalWidth >= 25) return;

        const itemFormat = imgElement.getAttribute('data-item-format');
        const parent = imgElement.parentNode;
        const fallback = document.createElement('img');

        fallback.setAttribute('data-item-format', itemFormat);
        fallback.setAttribute('alt', imgElement.alt);

        if (itemFormat === 'DVD' || itemFormat === 'BLURAY') {
            fallback.src = '/assets/images/reading-lists-movie-default.png';
        } else if (itemFormat === 'MUSIC_CD') {
            fallback.src = '/assets/images/reading-lists-music-default.png';
        } else {
            fallback.src = '/assets/images/reading-lists-book-default.png';
        }

        parent.replaceChild(fallback, imgElement);
    }

    handleDropdownTabs(_currentList) {
        const _dropdownTab = _currentList.querySelector('.opl-widget-reading-lists-tabs-dropdown');

        if (_dropdownTab) {
            const _dropdownTabList = _dropdownTab.nextElementSibling;
            const _dropdownTabListItems = _dropdownTabList.querySelectorAll('.opl-widget-reading-lists-tabs-item');

            if (_dropdownTabList && _dropdownTabListItems) {
                _dropdownTab.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.toggleDropdownTabs(_dropdownTab, _dropdownTabList);
                });

                _dropdownTab.addEventListener('keyup', (e) => {
                    e.preventDefault();
                    if (e.code === 'Enter' || e.code === 'Space') {
                        this.toggleDropdownTabs(_dropdownTab, _dropdownTabList);
                    }
                });

                _dropdownTabListItems.forEach(item => {
                    item.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.toggleDropdownTabs(_dropdownTab, _dropdownTabList, e.target.innerText);
                    });
                });
            }
        }
    }

    toggleDropdownTabs(_dropdownTab, _dropdownTabList, _activeTabLabel = '') {
        _dropdownTab.classList.toggle("active");
        _dropdownTabList.classList.toggle("active");

        if (_activeTabLabel) {
            _dropdownTab.innerText = _activeTabLabel;
        }
    }

    handleTabs(_currentList) {
        const _tabItems = _currentList.querySelectorAll('.opl-widget-reading-lists-tabs-item');
        const _tabContainers = _currentList.querySelectorAll('.opl-widget-reading-lists-tabs-container');

        if (_tabItems && _tabContainers) {
            _tabItems.forEach((tabItem) => {
                tabItem.addEventListener('click', (e) => {
                    e.preventDefault();
                    const targetTabID = e.target.dataset.tabId;

                    _tabItems.forEach((item) => item.classList.remove('active'));
                    _tabContainers.forEach((tabContainer) => tabContainer.classList.remove('active'));

                    e.target.classList.add('active');
                    document.getElementById(targetTabID).classList.add('active');
                });
            });
        }
    }
}
